import {Pipe, PipeTransform} from '@angular/core';
import {EventItem, EventStatus, League} from "@model";
import {TranslocoService} from "@ngneat/transloco";

@Pipe({
  name: 'leagueNextRound'
})
export class LeagueNextRoundPipe implements PipeTransform {

  constructor(private translocoService:TranslocoService) {
  }

  transform(value?: League): string {
    var round:number = 0;
    if (value) {
      let eventsToGo: number = this.calculateEventsToGo(value);
      round = ((value.events?.length ?? 0) - eventsToGo) + 1;
    }
    return this.translocoService.translate("league.round", {value:round});
  }

  private calculateEventsToGo(league?: League): number {
    var eventsToGo: number = 0;
    if (league && (league.events?.length ?? 0) > 0) {
      league!.events?.forEach((item: EventItem) => {
        if (item.status === EventStatus.ACTIVE) {
          eventsToGo++;
        }
      });
    }
    return eventsToGo;
  }
}
